export default __webpack_public_path__ + "static/media/Letter of Authority - Hendersons.a47d22c0.6a5e7516.pdf";